import React, { lazy } from 'react';
import { reportAccordionConfigs, spireonExtraTabsConfig } from './reportAccordionConfigs';
import { reportFormConfigs } from './reportFormConfigs';
import { hasEnabledFeature, findAndDeleteParentInJson, getAuthDetails } from 'globalutils/fmUtils';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const RenderForm = (props) => {
  return (
    <>
      <Form {...props} />
    </>
  );
};

export default function useAccordionList({ i18n, downloadReport, billOfLadingReport, ...rest }) {
  const SERVICE_PROVIDER = window?.$environment?.SERVICE_PROVIDER;
  const authDetails = getAuthDetails()?.enterpriseFeatureDto || {};
  const { spireonReportsEnabled, reportsEnabled } = authDetails;

  const getReports = (data, type) => downloadReport({ ...data, data: { ...data.data, type } });

  const triggerGetReports = (key) => (value) => getReports(value, key);

  const config = reportFormConfigs({ ...rest, i18n });

  const mapConfigToAccordion = (items) =>
    items
      .filter((item) => !item.condition || item.condition())
      .map(({ id, name, reportKey, dependency = '', reportType, fn }) => ({
        id,
        name,
        dependency,
        value: (
          <RenderForm
            {...config[reportKey]?.({
              fn: fn || triggerGetReports(reportType),
            })}
          />
        ),
      }));

  let accordionListArray = mapConfigToAccordion(reportAccordionConfigs({ i18n, ...rest, SERVICE_PROVIDER }));
  const spireonExtraTabs = mapConfigToAccordion(spireonExtraTabsConfig({ i18n, ...rest }));

  const addBillOfLadingIfNeeded = () => {
    if (checkServiceProvider('addBillOfLadingIfNeeded', SERVICE_PROVIDER, false)) {
      accordionListArray.push({
        id: 'BILL_OF_LADING_REPORT',
        name: i18n.t('reportPage.billOfLading'),
        value: <RenderForm {...config['malFunctionReport']?.({ fn: billOfLadingReport })} />,
        dependency: '',
      });
    }
  };

  const applySpireonOverrides = () => {
    if (checkServiceProvider('applySpireonOverrides', SERVICE_PROVIDER, false)) {
      if (!reportsEnabled) {
        accordionListArray = [];
        return;
      }
      if (spireonReportsEnabled) {
        const excludedIds = new Set(['HOS_VIOLATIONS_DETAIL', 'UNASSIGNED_DRIVING_REPORT']);
        accordionListArray = accordionListArray.filter((item) => !excludedIds.has(item.id));
        accordionListArray.push(...spireonExtraTabs);
      }
    }
  };

  const setItems = () => {
    if (!hasEnabledFeature('geometrisEnabled')) {
      accordionListArray = findAndDeleteParentInJson(accordionListArray, 'dependency', 'geometrisEnabled');
    }
    accordionListArray.forEach((ele) => {
      if (ele.dependency && !hasEnabledFeature(ele.dependency)) {
        accordionListArray = findAndDeleteParentInJson(accordionListArray, 'dependency', ele.dependency);
      }
    });
    addBillOfLadingIfNeeded();
    applySpireonOverrides();
  };

  setItems();

  return { accordionListArray };
}
